// extracted by mini-css-extract-plugin
export default {"container":"Home_container__qRlyu","head":"Home_head__CVkcr","title":"Home_title__1aNQh","right":"Home_right__NI5UE","paging":"Home_paging__t+vTZ"};